import Vue from "vue";
import http from './http'
import store from './../store/index'

function isWechat() {
  var ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
}



function getQueryUserInfo(query) {
  console.log('query', query)
  if (query?.kpi_user_id) {
    localStorage.setItem('kpi_user_id', query.kpi_user_id || 0)
  }
  if (query?.share_user_id) {
    localStorage.setItem('share_user_id', query.share_user_id || 0)
  }
  if (query?.act_id) {
    localStorage.setItem('act_id', query.act_id || 0)
  }
  if (query?.brand_id) {
    localStorage.setItem('brand_id', query.brand_id || 0)
  }
  if (query?.shop_id) {
    localStorage.setItem('shop_id', query.shop_id || 0)
  }
  if (query?.inviteId) {
    localStorage.setItem('inviteId', query.inviteId || 0)
  }


}
function getLocation() {
  return new Promise((resolve) => {
    wx.getLocation({
      type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: async function (res) {
        console.log('location success', res)
        let result = await http.get('/v1/location/locate', {
          location: `${res.latitude},${res.longitude}`
        })
        if (result.code === 0) {
          Object.assign(res, result)
          localStorage.setItem('location', JSON.stringify(res))
          resolve()
        }
      },
      fail: function (e) {
        console.log('location fail', e)
      },
      cancel: function (res) {
        console.log('用户拒绝授权获取地理位置', res);
        Vue.prototype.$dialog({
          message:
            "为了更好让您体验到就近门店的配套服务，我们需要获知您所在的城市区域，请允许我们获取您的位置信息",
        })
          .then(() => {
            getLocation();
          });
      },
      complate: function (e) {
        console.log('location complate', e)
      }
    });
  })

}


function checkLocation() {
  return new Promise(resolve => {
    http.post("/v1/home/check_location").then(res => {
      if (res.code === 0) {
        store.commit("setCanJoinAct", res.data);
        resolve()
      }
    });
  })

}


function updateUserInfo() {
  return new Promise(resolve => {
    http.post('/v1/kpiuser/refresh_login').then(res => {
      if (res.code === 0) {
        localStorage.setItem("token", res.data.wxToken);
        localStorage.setItem("userName", res.data.nickname);
        localStorage.setItem("avatarUrl", res.data.avatar);
        localStorage.setItem("openid", res.data.openid);
        localStorage.setItem("user_id", res.data.userId);
        localStorage.setItem("kpiUserStatus", res.data.kpiUserStatus);
        localStorage.setItem("actName", res.data.actName); //当前活动名称
        store.commit('setActName', res.data.actName)
        if (res.data.userType === 'cus') {
          // 客户
          localStorage.setItem("userType", res.data.userType);
          localStorage.setItem("kpi_user_id", res.data.inviteKpiUserId);
          localStorage.setItem("brand_id", res.data.inviteBrandId);
          localStorage.setItem("shop_id", res.data.inviteShopId);

        } else if (res.data.userType === 'kpi') {
          // kpi用户
          localStorage.setItem("userType", res.data.kpiUserType);
          localStorage.setItem("kpi_user_id", res.data.kpiUserId);
          localStorage.setItem("inviteId", res.data.inviteId || 0);
          localStorage.setItem("brand_id", res.data.brandId);
          localStorage.setItem("shop_id", res.data.shopId);
          localStorage.setItem("kpiRealName", res.data.kpiUserName); //KPI用户名的注册姓名
          localStorage.setItem("kpiUserMobile", res.data.kpiUserMobile); //KPI用户名的注册手机
          localStorage.setItem("kpiBrandName", res.data.brandName); //KPI用户的对应品牌名


        }
        resolve(res.data)
      }



    })
  })

}

function checkEnroll() {
  return new Promise(resolve => {
    http.post("/v1/home/check_enroll_status").then((res) => {
      if (res.code === 0) {
        // store.commit("setEnrollStatus", res.data ? 'enrolled' : 'no_enroll');
        localStorage.setItem("setEnrollStatus", res.data ? 'enrolled' : 'no_enroll');
        resolve()
      }
      // else if (res.code === 20508) {
      //   store.commit("setEnrollStatus", 'act_no_start');
      // } 
      else if (res.code === 20509) {
        // store.commit("setEnrollStatus", 'act_ended');
        localStorage.setItem("setEnrollStatus", "act_ended");
      }
    });
  })
}

function sleep (timeout) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, timeout || 500);
  })
}

function createRouterItem(data = {}) {
  return Object.assign({
    path: "",
    meta: {
      title: ''
    },
    component: '',
  }, data)
}

function getMyPagePath () {
  const path = localStorage.getItem('myPagePath') || '/mynew'
  return path
}
window.getMyPagePathGlobal = getMyPagePath
function getSeckillDetailPath () {
  const path = localStorage.getItem('seckillDetailPath') || '/seckillDetailbase'
  return path
}
export default {
  isWechat,
  getQueryUserInfo,
  getLocation,
  updateUserInfo,
  checkEnroll,
  sleep,
  createRouterItem,
  checkLocation,
  getMyPagePath,
  getSeckillDetailPath
};